import React from 'react'
import IconSearchNoResults from '../images/icons/search-no-results.svg'

const NoResults = ({searchString}) => {
  return (
    <div className="no-results text-center gutter-top">
      <svg>
        <use xlinkHref={`#${IconSearchNoResults.id}`}/>
      </svg>
      <p>No results for <strong>{searchString}</strong></p>
    </div>
  )
}

export default NoResults
